import Velocity from "velocity-animate";
import { adSubdomain, isSmallDevice } from "@/common/functions";
// StarButton was replaced by CopyButton
// import StarButton from "@/components/StarButton/StarButton.vue";
import CopyButton from "@/components/CopyButton/CopyButton.vue";
import SynonymThumbsVote from "@/components/Synonym/SynonymThumbsVote/SynonymThumbsVote.vue";
import PopOut from "@/components/PopOut/PopOut.vue";
import { mapGetters } from "vuex";

export default {
    name: "SingleSynonym",
    components: {
        // StarButton,
        CopyButton,
        SynonymThumbsVote,
        PopOut
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            subdomain: adSubdomain(this.$route.meta.subdomain),
            // StarButton was replaced by CopyButton
            // clicked: false,
            isPopOutVisible: false,
            thumbUp: false,
            thumbDown: false,
            copied: false
        };
    },
    computed: {
        ...mapGetters("Login", [
            "user" /* StarButton was replaced by CopyButton "getUserStarredWords", */,
            "getUpvotedWords",
            "getDownvotedWords"
        ]),
        ...mapGetters("ThesaurusFilter", ["getCopiedSynonym"]),
        headword() {
            return this.item.word.headword || this.item.word.slug;
        },
        visibleTypeOfWord() {
            return this.item.type !== "SYNONYMS" && this.item.type !== "IDIOMS";
        },
        id() {
            return this.item.word.relationId;
        },
        hasEntry() {
            return this.item.word.hasEntry;
        },
        synonymRef() {
            const { word } = this.item;
            return `${word.slug}-${word.relationId}`;
        }
    },
    watch: {
        item(oldValue, newValue) {
            if (newValue.word.relationId !== oldValue.word.relationId) {
                // StarButton was replaced by CopyButton
                //    this.initStaredWords();
                this.initUpvotedWords();
                this.initDownvotedWords();
            }
        },
        getCopiedSynonym() {
            const { relationId } = this.item.word;

            if (this.getCopiedSynonym && this.getCopiedSynonym.relationId === relationId) {
                if (!this.copied) {
                    this.copied = true;

                    setTimeout(() => {
                        this.copied = false;
                    }, 1800);
                }
            } else {
                this.copied = false;
            }
        },
        // StarButton was replaced by CopyButton
        // getUserStarredWords() {
        //     this.initStaredWords();
        // },
        getUpvotedWords() {
            this.initUpvotedWords();
        },
        getDownvotedWords() {
            this.initDownvotedWords();
        }
    },
    methods: {
        // StarButton was replaced by CopyButton
        // initStaredWords() {
        //     this.clicked = this.getUserStarredWords.includes(this.id);
        // },
        isSmallDevice,
        initUpvotedWords() {
            this.thumbUp = this.getUpvotedWords.includes(this.id);
        },
        initDownvotedWords() {
            this.thumbDown = this.getDownvotedWords.includes(this.id);
        },
        documentClick(e) {
            let popout = this.$refs.popoutMenu || null;
            let btn = this.$refs.definition || null;
            let target = e.target;

            if (
                btn &&
                popout &&
                popout !== target &&
                !popout.$el.contains(target) &&
                btn !== target &&
                !btn.contains(target)
            ) {
                this.isPopOutVisible = false;
            }
        },
        // Copy tooltip animation
        beforeEnterCopyTooltip(el) {
            const x = this.$refs[this.synonymRef].offsetWidth;
            const space = this.isSmallDevice() ? 20 : 25;
            el.style.opacity = 0;
            el.style.transform = `translate3d(${x + space}px, -50%, 0)`;
        },
        enterCopyTooltip(el, done) {
            Velocity(el, { opacity: "1" }, { duration: 250 }, { complete: done });
        },
        leaveCopyTooltip(el, done) {
            Velocity(el, { opacity: "0" }, { duration: 150 }, { complete: done });
        }
        // StarButton was replaced by CopyButton
        // Synonym bg animation hooks
        // enter(el, done) {
        //     Velocity(el, { translateX: "0" }, { duration: 370 });
        //     Velocity(
        //         el,
        //         { opacity: "0.35" },
        //         { queue: false },
        //         { duration: 350 },
        //         { complete: done }
        //     );
        // },
        // leave(el, done) {
        //     Velocity(el, { opacity: "0" }, { duration: 350 });
        //     Velocity(
        //         el,
        //         { translateX: "-100%" },
        //         { queue: false },
        //         { duration: 370 },
        //         { complete: done }
        //     );
        // }
    },
    created() {
        // StarButton was replaced by CopyButton
        //   this.initStaredWords();
        this.initUpvotedWords();
        this.initDownvotedWords();
        document.addEventListener("click", this.documentClick);
    },
    destroyed() {
        document.removeEventListener("click", this.documentClick);
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SingleSynonym/SingleSynonym.js